import React from "react";
import { Typography, Button, Badge, Switch } from "antd";
import { DashboardOutlined, MessageOutlined, BulbOutlined, BulbFilled } from "@ant-design/icons";
import PropTypes from "prop-types";
import { useSignalR } from "Common/hooks/context/SingleRContext";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;
export const AdminHeader = ({ darkMode, toggleDarkMode }) => {
  const { unreadMessages } = useSignalR();
  const navigate = useNavigate();
  const styles = {
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 24,
    },
    headerTitle: {
      margin: 0,
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : "#1a1a1a",
    },
    headerActions: {
      display: "flex",
      gap: 16,
      alignItems: "center",
    },
    badgeIcon: {
      fontSize: 20,
      color: darkMode ? "rgba(255, 255, 255, 0.65)" : undefined,
    },
  };
  return (
    <div style={styles.header}>
      <Title level={2} style={styles.headerTitle}>
        <DashboardOutlined /> LMS Admin Dashboard
      </Title>
      <div style={styles.headerActions}>
        <Badge count={unreadMessages} size="small" offset={[0, 6]}>
          <Button
            type="text"
            onClick={() => navigate("/messaging")}
            icon={<MessageOutlined style={styles.badgeIcon} />}
            shape="circle"
          />
        </Badge>
        <Switch
          checkedChildren={<BulbFilled />}
          unCheckedChildren={<BulbOutlined />}
          checked={darkMode}
          onChange={toggleDarkMode}
        />
      </div>
    </div>
  );
};
AdminHeader.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  toggleDarkMode: PropTypes.func.isRequired,
};
